import { IActionContext } from '@msdyn365-commerce/core';

export const createCanonicalUrl = (context: IActionContext, paths: string[], page: string) => {
    let canonicalDomainHost = `https://${context.requestContext.canonicalDomain}`;
    if (process.env.NODE_ENV === 'development') {
        canonicalDomainHost = '';
    }

    const sitePath = context.requestContext.sitePath ?? '';

    const url = `${canonicalDomainHost}${sitePath}/${paths
        .map(p => toSlug(p))
        .filter(s => s.length > 0)
        .join('/')}/${page}`;
    return url;
};

const toSlug = (text: string) => {
    const slug = text
        .toLowerCase()
        .replace(/[^A-Za-z\u00C0-\u017F0-9]/g, '-')
        .replace(/--+/g, '-')
        .replace(/^-/, '')
        .replace(/-$/, '');

    return slug;
};
